export const GET_EXCEPTION = "GET_EXCEPTION";
export const GET_EXCEPTION_SUCCESS = "GET_EXCEPTION_SUCCESS";
export const GET_EXCEPTION_ERROR = "GET_EXCEPTION_ERROR";

export const POST_EXCEPTION = "POST_EXCEPTION";
export const POST_EXCEPTION_SUCCESS = "POST_EXCEPTION_SUCCESS";
export const POST_EXCEPTION_ERROR = "POST_EXCEPTION_ERROR";
